import { messages as messagesEn } from './en/messages'
import { messages as messagesCs } from './cs/messages'
import { messages as messagesRu } from './ru/messages'
import { messages as messagesSk } from './sk/messages'
import { messages as messagesEs } from './es/messages'
import { messages as messagesIt } from './it/messages'
import { messages as messagesEl } from './el/messages'

export const catalogs = {
  en: messagesEn,
  cs: messagesCs,
  ru: messagesRu,
  sk: messagesSk,
  es: messagesEs,
  it: messagesIt,
  el: messagesEl,
}
